<div class="d-super-social">
  <img src="assets/images/super-social/logo_super_social.png" alt="Logo Super Social" class="d-super-social__logo">

  <ion-text class="ion-text-center">
    <h1>REGRAS</h1>
  </ion-text>

  <ion-text>
    <span class="d-super-social__botao-pode-participar">
      QUEM PODE PARTICIPAR
    </span>
    <p>
      O Programa Supersocial é destinado a <b>famílias com renda de até 1 (um) salário mínimo</b>, oferecendo condições
      de
      pagamento mais acessíveis para a regularização do imóvel.
    </p>
  </ion-text>

  <div class="d-super-social__step">
    <img src="assets/images/super-social/step_01.svg" alt="Fase 1" class="d-super-social__step__logo">
    <ion-text class="ion-text-center">
      <h2 class="d-super-social__step__title d-super-social__step__text-orange">
        CADASTRO NO APLICATIVO
      </h2>
      <p>O morador realiza seu cadastro no app.</p>
    </ion-text>
  </div>
  <div class="d-super-social__step">
    <img src="assets/images/super-social/step_02.svg" alt="Fase 2" class="d-super-social__step__logo">
    <ion-text class="ion-text-center">
      <h2 class="d-super-social__step__title d-super-social__step__text-light-blue">
        ASSINATURA DO CONTRATO <br> E PAGAMENTO DA ENTRADA
      </h2>
      <p>
        O contrato é assinado digitalmente e a entrada é gerada automaticamente. Esta é a única parcela emitida antes
        da análise.
      </p>
    </ion-text>
  </div>
  <div class="d-super-social__step">
    <img src="assets/images/super-social/step_03.svg" alt="Fase 3" class="d-super-social__step__logo">
    <ion-text class="ion-text-center">
      <h2 class="d-super-social__step__title d-super-social__step__text-dark-blue">
        DECLARAÇÃO DE RENDA <br> E ENVIO DE DOCUMENTOS
      </h2>
      <p>
        O contrato é assinado digitalmente e a entrada é gerada automaticamente. Esta é a única parcela emitida antes da
        análise.
      </p>
    </ion-text>
  </div>
  <div class="d-super-social__step">
    <img src="assets/images/super-social/step_04.svg" alt="Fase 4" class="d-super-social__step__logo">
    <ion-text class="ion-text-center">
      <h2 class="d-super-social__step__title d-super-social__step__text-yellow">
        VÍDEO-DEPOIMENTO
      </h2>
      <p>
        Após finalizar as etapas no app, o participante deve enviar um vídeo curto (até 2 minutos) para o e-mail
        <a class="d-super-social__step__text-yellow" href="mailto:instituto@usucampeao.com.br">
          instituto@usucampeao.com.br
        </a>, respondendo: <br>
        👉 “Por que é importante para você e sua família ter sua casa regularizada?”
      </p>
    </ion-text>
  </div>
  <div class="d-super-social__step">
    <img src="assets/images/super-social/step_05.svg" alt="Fase 5" class="d-super-social__step__logo">
    <ion-text class="ion-text-center">
      <h2 class="d-super-social__step__title d-super-social__step__text-blue">
        ANÁLISE DA SITUAÇÃO</h2>
      <p>
        O Comitê do Instituto Campeão avaliará os documentos e o vídeo. Será emitido um documento de
        <span class="d-super-social__step__text-blue">Análise da Situação</span>, que o morador deve assinar
        digitalmente para confirmar sua participação.
      </p>
    </ion-text>
  </div>
  <div class="d-super-social__step">
    <img src="assets/images/super-social/step_06.svg" alt="Fase 6" class="d-super-social__step__logo">
    <ion-text class="ion-text-center">
      <h2 class="d-super-social__step__title d-super-social__step__text-green">
        Resultado
      </h2>
      <p>
        ✅ <span class="d-super-social__step__text-green">SE APROVADO</span>: os boletos futuros serão atualizados com o
        desconto especial do Supersocial.
        <br> <br>
        ❌ <span class="d-super-social__step__text-red">SE NÃO APROVADO</span>: o morador poderá escolher: Rescindir o
        contrato (distrato formal), ou Assinar um novo
        contrato nos valores padrão, usando o valor da entrada já paga como crédito.
      </p>
    </ion-text>
  </div>

  <ion-text>
    <span class="d-super-social__botao-pode-participar">
      QUEM PODE PARTICIPAR
    </span>
  </ion-text>

  <div class="d-super-social__info-item">
    <ion-icon mode="md" color="secondary" name="play"></ion-icon>
    <p>
      O participante só será incluído na lista de beneficiários que receberão o documento após assinar a Análise da
      Situação concordando com a decisão do Comitê.
    </p>
  </div>
  <div class="d-super-social__info-item">
    <ion-icon mode="md" color="secondary" name="play"></ion-icon>
    <p>
      Caso o participante não concorde, deverá formalizar o distrato do contrato.
    </p>
  </div>
  <div class="d-super-social__info-item">
    <ion-icon mode="md" color="secondary" name="play"></ion-icon>
    <p>
      A entrada já paga não é perdida: em caso de novo contrato, será transferida como crédito.
    </p>
  </div>

  <ion-text>
    <p>
      Com o Supersocial, você garante condições especiais para regularizar sua casa e ainda fortalece sua comunidade
      participando das ações do Instituto Campeão.
    </p>
  </ion-text>
</div>